// extracted by mini-css-extract-plugin
module.exports = {"controlCell":"style_controlCell__3qdLY","lastColumn":"style_lastColumn__3mwCT","scopeCell":"style_scopeCell__3oBbG","fullSizeCell":"style_fullSizeCell__1SimM"};